import classnames from 'classnames'
// Components
import { Button } from '../../../..'
import { IconAngleRight, IconAngleLeft } from '../../../../shared/Icon'
// Styles
import styles from './ArrowButton.module.scss'

export interface ArrowButtonProps {
  onClick?: () => void
  className?: string
  isLeftArrow: boolean
}

const ArrowButton = ({ onClick, className, isLeftArrow }: ArrowButtonProps) => {
  // Slick injects a bunch of classes that ruin my life
  const disabled = className?.includes('slick-disabled')
  className = className
    ?.replace(/slick-next|slick-prev|slick-arrow|slick-disabled/g, '')
    .trim()

  return (
    <Button
      className={classnames(
        styles.slickArrow,
        className,
        disabled && styles.disabled
      )}
      onClick={onClick}
      aria-label={`${isLeftArrow ? 'previous' : 'next'} arrow button`}
    >
      {isLeftArrow ? (
        <IconAngleLeft className={styles.icon} />
      ) : (
        <IconAngleRight className={styles.icon} />
      )}
    </Button>
  )
}

export default ArrowButton
